export const FIRST_FRIDAYS_KEY = "theotokos-first-fridays-v2";
export const validMonth = (month) => typeof month === "string" && /^(19|20|21)\d{2}-(0[1-9]|1[0-2])$/.test(month);
export const monthKey = (date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
export const firstFriday = (year, month) => {
  const start = new Date(year, month, 1);
  return new Date(year, month, 1 + (5 - start.getDay() + 7) % 7);
};
export const suggestedStart = (today) => {
  const day = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  return monthKey(firstFriday(today.getFullYear(), today.getMonth()) < day ? new Date(today.getFullYear(), today.getMonth() + 1, 1) : day);
};
export const nineFridays = (start) => {
  const [year, month] = start.split("-").map(Number);
  return Array.from({ length: 9 }, (_, i) => {
    const date = firstFriday(year, month - 1 + i);
    const id = monthKey(date);
    return { id, date, iso: `${id}-${String(date.getDate()).padStart(2, "0")}` };
  });
};
export const readFirstFridays = (today) => {
  const fallback = { start: suggestedStart(today), done: [] };
  try {
    const saved = JSON.parse(localStorage.getItem(FIRST_FRIDAYS_KEY));
    if (saved && validMonth(saved.start)) {
      const allowed = nineFridays(saved.start).map((f) => f.id);
      return { start: saved.start, done: [...new Set(Array.isArray(saved.done) ? saved.done.filter((id) => allowed.includes(id)) : [])] };
    }
    const legacy = JSON.parse(localStorage.getItem("theotokos-first-fridays-v1"));
    if (legacy && typeof legacy === "object" && !Array.isArray(legacy)) {
      const done = Object.keys(legacy).filter((key) => validMonth(key) && legacy[key] === true).sort();
      if (done.length) return { start: done[0], done: done.filter((id) => nineFridays(done[0]).some((f) => f.id === id)) };
    }
  } catch { /* Corrupt or unavailable storage must not break prayer. */ }
  return fallback;
};